import React from 'react';
import { testimonials, testimonialsTitle } from '../data/content';
export function Testimonials() {
  return <section className="bg-ivory text-ink" data-id="element-187" data-mp="3krfbd6d3y6fd">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-6 lg:py-20" data-id="element-188" data-mp="3ksgxc5vnwdbv">
        <h2 className="mx-auto max-w-2xl text-center font-display text-[1.45rem] font-medium italic leading-snug tracking-tight sm:text-3xl" data-id="element-189" data-mp="3fy2yfthsjo2g">
          {testimonialsTitle}
        </h2>

        <div className="mx-auto mt-8 grid max-w-5xl gap-3 md:grid-cols-3 md:gap-4" data-id="element-190" data-mp="36zr015aonlzg">
          {testimonials.map(item => <figure key={item.name} className="flex flex-col rounded-2xl border border-stone bg-ivory-card p-5 sm:p-6" data-id="element-191" data-mp="31yl8vbwo86s1">
              <blockquote className="font-display text-[1.1rem] leading-snug text-ink" data-id="element-192" data-mp="2s1q8engu7wb4">{item.quote}</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-193" data-mp="v96la316w1l1">
                <span aria-hidden="true" className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-sage/20 font-display text-sm font-semibold text-sage-deep" data-id="element-194" data-mp="v72ixpixvamv">
                  {item.name.charAt(0)}
                </span>
                <span className="font-sans text-sm text-ink/70" data-id="element-195" data-mp="m2ydyndqabto">
                  <span className="font-semibold text-ink" data-id="element-196" data-mp="7926srtb7p81">{item.name}</span>, {item.age}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}